<script>
import Layout from '@layouts/public.vue'
import axios from 'axios'
import LoadingView from './_loading.vue'

export default {
  name: 'TimeoutView',
  metaInfo() {
    return {
      title: this.$t('timeout.timeoutPageTitle'),
      meta: [
        {
          name: 'description',
          content: this.$t('timeout.timeoutMetaDescription'),
        },
      ],
    }
  },
  components: { Layout, LoadingView },
  data() {
    return {
      offlineConfirmed: false,
    }
  },
  beforeCreate() {
    axios
      .head('/api/ping')
      .then(() => {
        window.location.reload()
      })
      .catch(() => {
        this.offlineConfirmed = true
      })
  },
}
</script>

<template>
  <Layout v-if="offlineConfirmed">
    <h1 :class="$style.title">
      The page timed out while loading. Are you sure you're still connected to
      the Internet?
    </h1>
  </Layout>
  <LoadingView v-else />
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
